'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SyntheticEventClass = function () {
  function SyntheticEventClass(value, evt) {
    _classCallCheck(this, SyntheticEventClass);

    var target = {
      value: value
    };
    this.target = target;
    this.currentTarget = target;
    this.source = evt;
  }

  _createClass(SyntheticEventClass, [{
    key: 'preventDefault',
    value: function preventDefault() {
      if (this.source) {
        this.source.preventDefault();
      }
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation() {
      if (this.source) {
        this.source.stopPropagation();
      }
    }
  }]);

  return SyntheticEventClass;
}();

function SyntheticEvent(value, evt) {
  return new SyntheticEventClass(value, evt);
}

SyntheticEvent.constructor = SyntheticEventClass;

exports.default = SyntheticEvent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/core/SyntheticEvent.js
// module id = 9
// module chunks = 171